import { doc, onSnapshot, type Unsubscribe } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import type { User } from "firebase/auth";
import { db, functions } from "./firebase";

export const OWNER_UID = "UniFGlIzK4QqkYqnMCh0tavlSZs1";
export type AccessState =
  | "checking"
  | "owner"
  | "approved"
  | "trialing"
  | "active"
  | "grace_period"
  | "complimentary"
  | "read_only"
  | "expired"
  | "suspended";

const knownStates = new Set<AccessState>([
  "owner",
  "approved",
  "trialing",
  "active",
  "grace_period",
  "complimentary",
  "read_only",
  "expired",
  "suspended",
]);

export function canReadWorkspace(state: AccessState) {
  return ["owner", "approved", "trialing", "active", "grace_period", "complimentary", "read_only", "expired"].includes(state);
}

export function canWriteWorkspace(state: AccessState) {
  return ["owner", "approved", "trialing", "active", "grace_period", "complimentary"].includes(state);
}

export function observeUserAccess(user: User, onChange: (state: AccessState) => void, onError: (message: string) => void): Unsubscribe {
  if (user.uid === OWNER_UID) {
    onChange("owner");
    void httpsCallable(functions, "bootstrapAccount")({}).catch(() => undefined);
    return () => {};
  }
  const accessRef = doc(db, "userAccess", user.uid);
  let active = true;
  const unsubscribe = onSnapshot(accessRef, (snapshot) => {
    const status = snapshot.data()?.status;
    if (typeof status === "string" && knownStates.has(status as AccessState)) onChange(status as AccessState);
  }, (reason) => onError(reason.message));

  void httpsCallable(functions, "bootstrapAccount")({}).catch((reason: unknown) => {
    if (!active) return;
    onError(reason instanceof Error ? reason.message : "Unable to start your account.");
  });
  return () => {
    active = false;
    unsubscribe();
  };
}
